<template>
  <overlay
    key="back-in-stock-drawer"
    :focus-return="config.focusReturn"
    block-class="back-in-stock-drawer"
    :direction="isMobile ? 'up' : 'left'"
    mobile-drag-close
    :overlay-label="config.strings.label ? config.strings.label : ''"
    namespace="back-in-stock-drawer"
    show-close
    :type="isMobile ? 'shelf-modal' : 'drawer'"
  >
    <template #body>
      <div
        v-if="isMobile"
        class="back-in-stock-drawer__back-btn"
      >
        <button
          v-if="config.strings.back"
          class="back-in-stock-drawer__close-btn"
          type="button"
          @click="handleCloseOverlay('back-in-stock-drawer')"
        >
          <icon-arrow-left />

          <span
            class="text-body-2xs-regular"
            v-text="config.strings.back"
          />
        </button>
      </div>

      <div
        v-if="!config.isSubmitted && variant"
        class="back-in-stock-drawer__details"
      >
        <div
          :key="variant"
          class="back-in-stock-drawer__product-info"
        >
          <div class="back-in-stock-drawer__product">
            <h2
              :id="`product-title-${product?.handle}`"
              class="back-in-stock-drawer__title font-family-freight"
              v-text="$string('product.back_in_stock.title')"
            />
            <p
              :id="`variant-title-${product?.handle}`"
              class="back-in-stock-drawer__subtitle text-body-2xs-regular"
              v-text="$string( 'product.back_in_stock.heading', {
                replace: { size: sizeOptionValue }
              })"
            />
          </div>
        </div>

        <klaviyo-bis-form
          :key="variant?.id"
          :accepts-marketing="acceptsMarketing"
          cta-text=""
          :display-text="$string('product.back_in_stock.email_placeholder')"
          :product="product"
          :variant="variant"
          @update-email="() => {}"
          @form-submitted="handleFormSubmitted"
        />
        <div class="back-in-stock-drawer__field back-in-stock-drawer__consent">
          <input
            id="back-in-stock-drawer--consent"
            v-model="acceptsMarketing"
            type="checkbox"
          >
          <label for="back-in-stock-drawer--consent">
            <span class="back-in-stock-drawer__checkbox">
              <icon-check-alt />
            </span>
            <span v-text="$string('product.back_in_stock.subscribe')" />
          </label>
        </div>

        <div
          class="back-in-stock-drawer__privacy-policy"
          v-html="$string('product.back_in_stock.privacy_policy_html')"
        />
      </div>

      <div
        v-else-if="config.isSubmitted && variant"
        class="back-in-stock-drawer__continue-shopping"
      >
        <h2
          class="back-in-stock-drawer__title font-family-freight"
          v-text="$string('product.back_in_stock.success')"
        />
        <p
          class="back-in-stock-drawer__subtitle text-body-2xs-regular"
          v-text="$string('product.back_in_stock.success_message')"
        />
        <btn
          :label="$string('product.cta.continue_shopping')"
          modifiers="primary block center"
          type="button"
          @click="handleCloseOverlay('back-in-stock-drawer')"
        />
      </div>

      <div class="back-in-stock-drawer__recommendations" />
    </template>
  </overlay>
</template>

<script>

/**
 * Vue: Back in stock drawer (back-in-stock-drawer)
 * -----------------------------------------------------------------------------
 * A back in stock drawer for notify me functionality.
 */

import { mapActions, mapState } from 'vuex'

import IconArrowLeft from '~icons/directional-navigation/arrow/left.svg'
import IconCheckAlt from '~icons/general/check-alt.svg'

import Btn from '~global/btn/btn'
import Overlay from '~global/overlay/overlay'
import KlaviyoBisForm from '~async/klaviyo-bis/klaviyo-bis-form'

export default {
  name: 'BackInStockDrawer',

  components: {
    Btn,
    IconArrowLeft,
    IconCheckAlt,
    KlaviyoBisForm,
    Overlay,
  },

  data() {
    return {
      acceptsMarketing: false,
      cnvsGlobal: true,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
      config: (state) => state.backInStockDrawer.config,
      product: (state) => state.backInStockDrawer.product,
      variant: (state) => state.backInStockDrawer.variant,
    }),

    sizeOptionValue() {
      return this.variant?.selectedOptions?.find(
        (option) => option.name.toLowerCase() === 'size' || option.name.toLowerCase() === 'taille',
      ).value || ''
    },
  },

  mounted() {
    cnvs.EventBus.listen('backInStockDrawer:customFocus', (customFocus) => {
      const focusReturnEl = customFocus ? document.querySelector(customFocus) : false

      if (focusReturnEl) {
        setTimeout(() => {
          focusReturnEl.focus({ preventScroll: true })
        }, this.$timing('slow'))
      }
    })
  },

  methods: {

    /**
     * Overlay actions
     */
    ...mapActions({
      closeOverlay: 'overlays/close',
      setConfig: 'backInStockDrawer/setConfig',
    }),

    /**
     * Handles back in stock modal display
     */
    handleCloseOverlay(nameSpace) {
      this.closeOverlay(nameSpace)
      cnvs.EventBus.emit('backInStockDrawer:customFocus', this.config.focusReturn)
    },

    /**
     * Handles Klaviyo BIS form submission
     */
    handleFormSubmitted() {
      this.acceptsMarketing = false
      this.setConfig({
        ...this.config,
        isSubmitted: true,
      })
    },
  },
}
</script>
